import React from "react";


import { Button, Card, CardBody, Col, Container, Row } from "reactstrap";

// datatable related plugins
import "react-bootstrap-table2-filter/dist/react-bootstrap-table2-filter.min.css";

import { connect } from "react-redux";
import PropTypes from "prop-types";
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import RemoteTable from "../../../components/Common/RemoteTable";
import SweetAlert from "react-bootstrap-sweetalert";
import styled from "styled-components";
import CampaignAdvertisingAccountModal from "./components/CampaignAdvertisingAccountModal";
import {
  addCampaignAdvertisingAccount,
  deleteCampaignAdvertisingAccount,
  getCampaignAdvertisingAccountsList,
  updateCampaignAdvertisingAccountProfile,
  getCampaignCustomerData,
  postWHTrigger,
} from "../../../store/campaigns/advertising-accounts/actions";
import { getCampaignSourcesList } from "../../../store/campaigns/sources/actions";
import { INITIAL_DATA_PARAMS } from "../../../constants/store";
import { getCampaignCashbacksList } from "../../../store/campaigns/cashbacks/actions";
import WarehouseCabinetsModal from "./components/WarehouseCabinetsModal";
import ModifiedMetaTags from "../../../components/ModifiedMetaTags";

class AdvertisingAccounts extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      page: 1,
      sizePerPage: 10,
      filter_name: [],
      deleteAlert: null,
      viewAddCampaignAdvertisingAccount: false,
      viewWarehouseCabinets: false,
      editData: null,
    };
  }

  componentDidMount() {
    this.props.getCampaignAdvertisingAccountsList(INITIAL_DATA_PARAMS);
    this.props.getCampaignSourcesList({
      ...this.props.adPlatforms,
      sizePerPage: 0,
    });
    this.props.getCampaignCustomerData();
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.props.data !== prevProps.data) {
      this.props.data.results.forEach(it =>
        this.props.adPlatforms.results.forEach(pl => {
          if (pl.id === it.ad_platform) {
            it.ad_platform = pl.name;
          }
        })
      );
    }
  }

  handleChangeOrder = (row) => {
    switch (row) {
      case '-ad_platform':
        return '-ad_platform__name'
      case 'ad_platform':
        return 'ad_platform__name'
      default:
        return row;
    }
  }

  handleTableChange = data => {
    this.props.getCampaignAdvertisingAccountsList({
      ...data,
      ordering: this.handleChangeOrder(data.ordering),
    });
  };

  handleChangeDeleteAlert = data => {
    this.setState({ deleteAlert: data });
  };

  toggleViewAddAdvertisingAccountModal = () => {
    this.setState(prevState => ({
      viewAddCampaignAdvertisingAccount:
        !prevState.viewAddCampaignAdvertisingAccount,
      editData: null,
    }));
  };

  toggleViewWarehouseCabinets = () => {
    this.setState(prevState => ({
      viewWarehouseCabinets: !prevState.viewWarehouseCabinets,
    }));
  };

  render() {
    const actionsFormatter = (cell, row) => {
      const onClickDelete = () => {
        this.handleChangeDeleteAlert({
          title: `Delete "${row.name}"!`,
          onConfirm: () => {
            this.props.deleteCampaignAdvertisingAccount(row.id, {
              ...this.props.data,
              page:
                this.props.data.results.length === 1 ? 1 : this.props.data.page,
            });
            this.handleChangeDeleteAlert(null);
          },
        });
      };

      const onClickEdit = e => {
        onClickRow(e, row, "edit");
      };

      return (
        <React.Fragment>
          {this.props.permissions["change_campaigncabinetmodel"] && (
            <Button
              type="button"
              className="btn btn-primary  btn-sm"
              onClick={onClickEdit}
            >
              <i className="mdi mdi-circle-edit-outline d-block font-size-16" />
            </Button>
          )}
          {this.props.permissions["delete_campaigncabinetmodel"] && (
            <Button
              type="button"
              className="btn btn-danger btn-sm m-1"
              onClick={onClickDelete}
            >
              <i className="mdi mdi-trash-can d-block font-size-16" />
            </Button>
          )}
        </React.Fragment>
      );
    };

    const nameFormatter = (cell, row, label) => {
      return (
        <NameLink onClick={e => onClickRow(e, row, "edit")}>
          {row[label]}
        </NameLink>
      );
    };

    const nameFormatterWithCustomNames = (cell, row, label) => {
      return (
        <NameLink onClick={e => onClickRow(e, row, "edit")}>
          {row?.custom_name != null ? row['custom_name'] : row[label]}
        </NameLink>
      );
    };

    const CashbackFormatter = (cell, row, label) => {
      if (row[label].length > 0) {
        let items = [];
        row[label].map((i, k) => {
          items.push(i.name);
        });
        return (
          <NameLink onClick={e => onClickRow(e, row, "edit")}>
            {items.join(", ")}
          </NameLink>
        );
      } else {
        return "-";
      }
    };

    const onClickRow = (e, row, type) => {
      if (this.props.permissions?.["view_campaigncabinetmodel"]) {
        this.setState(prevState => ({
          viewAddCampaignAdvertisingAccount:
            !prevState.viewAddCampaignAdvertisingAccount,
          editData: type === "edit" ? row : null,
        }));
      }
    };

    const columns = [
      {
        dataField: "name",
        text: "Name",
        sort: true,
        formatter: (cell, row) => nameFormatterWithCustomNames(cell, row, "name"),
      },
      {
        dataField: "ad_platform",
        text: "Ad platform",
        sort: true,
        formatter: (cell, row) => nameFormatter(cell, row, "ad_platform"),
      },
      {
        dataField: "platform_cabinet_id",
        text: "Ad account platform id",
        sort: true,
        formatter: (cell, row) =>
          nameFormatter(cell, row, "platform_cabinet_id"),
      },
      {
        dataField: "cashbacks_detail",
        text: "Cashbacks",
        sort: true,
        formatter: (cell, row) =>
          CashbackFormatter(cell, row, "cashbacks_detail"),
      },
      {
        dataField: "actions",
        text: "Actions",
        sort: false,
        formatter: actionsFormatter,
      },
    ];

    return (
      <React.Fragment>
        {this.state.viewAddCampaignAdvertisingAccount && (
          <CampaignAdvertisingAccountModal
            toggle={this.toggleViewAddAdvertisingAccountModal}
            isOpen={this.state.viewAddCampaignAdvertisingAccount}
            data={this.props.data}
            cashbacks={this.props.cashbacks}
            adPlatforms={this.props.adPlatforms}
            addCampaignAdvertisingAccount={
              this.props.addCampaignAdvertisingAccount
            }
            updateCampaignAdvertisingAccountProfile={
              this.props.updateCampaignAdvertisingAccountProfile
            }
            editData={this.state.editData}
            permissions={this.props.permissions}
            customer_data={this.props.customer_data}
            getCampaignCashbacksList={this.props.getCampaignCashbacksList}
          />
        )}
        {this.state.viewWarehouseCabinets && (
          <WarehouseCabinetsModal
            toggle={this.toggleViewWarehouseCabinets}
            isOpen={this.state.viewWarehouseCabinets}
            adPlatforms={this.props.adPlatforms}
            permissions={this.props.permissions}
            postWHTrigger={this.props.postWHTrigger}
          />
        )}

        <div className="page-content">
        <ModifiedMetaTags title="Campaign advertising accounts  | Mobihunter" />
          <Container fluid>
            <Breadcrumbs
              title="Dashboard"
              breadcrumbItem="Advertising Accounts"
              link="/dashboard"
            />
            {this.state.deleteAlert && (
              <SweetAlert
                showCancel
                confirmBtnText="Delete"
                cancelBtnText="Cancel"
                confirmBtnBsStyle="danger"
                cancelBtnBsStyle=""
                title={this.state.deleteAlert.title}
                onCancel={() => this.handleChangeDeleteAlert(null)}
                onConfirm={this.state.deleteAlert.onConfirm}
              >
                <p>
                  You are about to delete this ad account? <br /> If you are not
                  sure, you can close this form.{" "}
                </p>
              </SweetAlert>
            )}

            <Row>
              <Col className="col-12">
                <Card>
                  <CardBody>
                    <RemoteTable
                      onTableChange={this.handleTableChange}
                      columns={columns}
                      data={this.props.data}
                      loading={this.props.loading}
                    >
                      {this.props.permissions[
                        "change_campaigncabinetmodel"
                      ] && (
                        <Button
                          type="button"
                          color="primary"
                          className="btn-rounded mb-2 me-2"
                          onClick={this.toggleViewWarehouseCabinets}
                        >
                          <i className="mdi mdi-update me-1" /> Load platforms
                          cabinets
                        </Button>
                      )}

                      {this.props.permissions &&
                        this.props.permissions["add_campaigncabinetmodel"] ===
                          "add_campaigncabinetmodel" && (
                          <Button
                            type="button"
                            color="success"
                            className="btn-rounded mb-2 me-2"
                            onClick={this.toggleViewAddAdvertisingAccountModal}
                          >
                            <i className="mdi mdi-plus me-1" /> Add campaign
                            advertising account
                          </Button>
                        )}
                    </RemoteTable>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

const NameLink = styled.div`
  transition-duration: 0.1s;

  &:hover {
    color: rgb(85, 110, 230);
    transition-duration: 0.1s;
  }
`;

AdvertisingAccounts.propTypes = {
  data: PropTypes.any,
  customer_data: PropTypes.object,
  cashbacks: PropTypes.any,
  loading: PropTypes.bool,
  getCampaignAdvertisingAccountsList: PropTypes.func,
  addCampaignAdvertisingAccount: PropTypes.func,
  deleteCampaignAdvertisingAccount: PropTypes.func,
  updateCampaignAdvertisingAccountProfile: PropTypes.func,
  getCampaignSourcesList: PropTypes.func,
  getCampaignCustomerData: PropTypes.func,
  getCampaignCashbacksList: PropTypes.func,
  postWHTrigger: PropTypes.func,
  adPlatforms: PropTypes.any,
  history: PropTypes.any,
  permissions: PropTypes.any,
};

const mapStateToProps = state => ({
  adPlatforms: state.CampaignSourceList.data,
  data: state.CampaignAdvertisingAccountList.data,
  customer_data: state.CampaignAdvertisingAccountList.customer_data,
  loading: state.CampaignAdvertisingAccountList.loading,
  cashbacks: state.CampaignCashbackList.data,
  permissions: state.User.permissions,
});

export default connect(mapStateToProps, {
  getCampaignAdvertisingAccountsList: getCampaignAdvertisingAccountsList,
  addCampaignAdvertisingAccount: addCampaignAdvertisingAccount,
  deleteCampaignAdvertisingAccount: deleteCampaignAdvertisingAccount,
  updateCampaignAdvertisingAccountProfile:
    updateCampaignAdvertisingAccountProfile,
  getCampaignSourcesList,
  getCampaignCustomerData,
  getCampaignCashbacksList,
  postWHTrigger,
})(AdvertisingAccounts);
